import { lazy } from 'react';
import Header from '../Header/Header';
import useLayoutConfig from '../../hooks/useLayoutConfig';
const LeftNavigation = lazy(() => import('../LeftNavigation'));
const Footer = lazy(() => import('../Footer/Footer'));

const Layout = ({ children }) => {
  const { isFullWidthRoute, layoutCommonClasses, defaultClasses } = useLayoutConfig();

  return (
    <main>
      <Header />
      <LeftNavigation />
      <div className={!isFullWidthRoute ? defaultClasses.wrapper : layoutCommonClasses.join(' ')}>
        <div className={!isFullWidthRoute ? defaultClasses.container : null}>{children}</div>
      </div>
      <Footer />
    </main>
  );
};

export default Layout;
